import { Component, HostBinding, Input } from '@angular/core';

import { defaultTotal } from '../../../../../../shared/total.helper';

@Component({
  standalone: false,
  selector: 'timesheet-day-info',
  templateUrl: './timesheet-day-info.component.html',
})
export class TimesheetDayInfoComponent {
  @Input()
  date: string;
  @Input()
  approvedTotal = defaultTotal;
  @Input()
  showSalary: boolean;
  @Input()
  scheduleDiff: number;
  @Input()
  show: boolean = true;
  @Input()
  last: boolean = true;

  @HostBinding('style.height.px')
  height = 36;
}
